export default __webpack_public_path__ + "static/media/all-corners-rounded-3.cff7e8fb.webp";